<template>
  <div class="price-field">
    <input id="price" ref="input" v-model="inputValue" type="text" style="height: 100% !important;" />
  </div>
</template>

<script>
import Vue from 'vue'
import cleaveMixin from '@/mixins/cleave-mixin'
import { formatPrice } from '@/lib/formatting.utils'

export default Vue.extend({
  mixins: [cleaveMixin],

  data: () => ({
    inputValue: null
  }),

  created() {
    const { getValueFromData, key, field } = this.params
    if (getValueFromData) this.inputValue = this.getUserFormat(this.params.data[key][field])
    else this.inputValue = formatPrice(this.params.value, this.params.decimals || 2)
    this.$nextTick(() => this.$refs.input.select())
  },

  mounted() {
    this.$nextTick(() => this.$refs.input.focus())
    this.inputPriceFormat('#price', this.params.decimals || 2)
  },

  methods: {
    getValue() {
      if (!this.inputValue) return null
      const delimiter = this.settings.thousand_separator === 'space' ? ' ' : this.settings.thousand_separator
      const separator = this.settings.decimal_separator
      return this.inputValue
        .split(delimiter)
        .join('')
        .replace(separator, '.')
    },

    getUserFormat(price) {
      if (!price) return ''
      return price.replace('.', this.settings.decimal_separator)
    }
  }
})
</script>

<style lang="stylus" scoped>
.price-field {
  position relative
  height 100%
  width 100%
  display grid
  justify-content center
  align-items center

  input {
    border 1px solid #b2b2b2 !important
    border-radius 6px
    width 100%
  }
}
</style>
